export const UPDATE_UTENTE_NUOVA_PASSWORD = 'UPDATE_UTENTE_NUOVA_PASSWORD';
export const SALVA_DATI_NUOVA_PASSWORD    = 'SALVA_DATI_NUOVA_PASSWORD';
export const INVIA_DATI_NUOVA_PASSWORD    = 'INVIA_DATI_NUOVA_PASSWORD';

